<!-- 影院列表 -->
<template>
  <div>
    <van-nav-bar
        title="影院列表"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="top">
      <div class="header" v-if="filmInfo.poster">
        <div class="header-bg" :style="{background:`url(${filmInfo.poster})`}" v-if="filmInfo.poster"></div>
        <div>
          <van-image
              fit="aspectFill"
              :src="`${filmInfo.poster}_180x180.jpg`"
              class="header-img"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </div>

        <div class="header-content">
          <div class="title">{{filmInfo.name}}</div>
          <div class="score">
            <span>{{filmInfo.score}}</span>（评分）
          </div>
          <div>{{filmInfo.type}}</div>
          <div>{{filmInfo.language}}/{{filmInfo.duration}}分钟</div>
          <div>{{filmInfo.opentime}}{{filmInfo.country}}上映</div>
        </div>
      </div>
    </div>
    <div class="head">
      <div class="cityName" @click="toLocation">
        <van-icon name="location-o" class="icon"/>{{cityName}}
      </div>
      <div class="cityName" @click="showAreaList = true">
        {{areaObj.cityName}}<van-icon name="arrow-down" class="icon"/>
      </div>
      <div class="search">
        <van-search v-model="form.keyword" placeholder="搜索影院名"/>
      </div>
    </div>
    <div>
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getCinemaList"
          class="list"
      >
        <div v-for="(item) in cinemaList" :key="item.cinemaid" class="cinema-list" @click="toCinema(item)">
          <div class="title">
            <div class="title-name">{{item.cinemaName || ''}}</div>
            <div class="distance" v-show="item.distance">{{item.distance || ''}}km</div>
          </div>
          <div class="address">{{item.address}}</div>
        </div>
      </van-list>
    </div>
    <van-popup v-model="showAreaList" round position="bottom">
      <van-picker show-toolbar title="选择行政区" :columns="areaList" @cancel="showAreaList = false" @confirm="confirmAreaId"/>
    </van-popup>

  </div>
</template>

<script>
import {getCinemaList, getMovieInfo, getAllCity} from '@/api/cinema'
export default {
  name: "cinemaList",
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      form: {
        movieId: '',
        city_id: '',
        latitude: '',
        longitude: '',
        keyword: '',
        page: 1,
        page_size: 100
      },
      cinemaList: [],
      filmInfo:{
        poster: '',
        name: '',
        grade: '',
        country: '',
        language: '',
        duration: '',
        opentime: '',
        director: '',
        type: '',
        version_types: '',
        description: '',
        actorList: [],
        imgList: [],
        showversionList: {string:[]},
      },
      showAreaList: false, //打开行政区列表
      areaList: [], // 行政区列表
      originalAreaList: [], // 行政区列表（原始数据）
      areaObj: { // 所选行政区
        cityName: '全部',
        cityCode: '',
        id: ''
      }
    }
  },
  methods: {
    getFilmInfo() {
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      getMovieInfo({
        movieId:this.form.movieId,
        city_id:this.city_id
      }).then(res=>{
        if(res?.data?.film_info?.showversion){
          res.data.film_info.showversionList = JSON.parse(res.data.film_info.showversion) || {string:[]}
          if(res.data.film_info?.showversionList?.string?.length){
            res.data.film_info.version_types = res.data.film_info.showversionList.string.join('，')
          }
        }else{
          res.data.film_info.version_types = ''
        }
        if(res?.data?.film_info?.trailerlist){
          res.data.film_info.imgList = res.data.film_info.trailerlist.split(',')
        }

        this.filmInfo = res?.data?.film_info || {}
      }).catch(e=>{
        console.log(e)
      }).finally(()=>{
        this.$Toast.clear()
      })
    },
    // 获取影院列表
    getCinemaList() {
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      let form = JSON.parse(JSON.stringify(this.form))
      if(this.areaObj.id){
        // form.areaid = this.areaObj.id //传参
        form.areaid = this.areaObj.cityCode //传参
      }
      form.city_id = this.cityCode
      if(this.cityPosition.latitude){
        form.latitude = this.cityPosition.latitude
        form.longitude = this.cityPosition.longitude
      }
      else{
        form.latitude = this.$route.query.latitude
        form.longitude = this.$route.query.longitude
      }
      this.loading = true
      getCinemaList(form).then(res => {
        this.cinemaList = res?.data?.list || []
        if(res?.data?.list?.length && res.data.list.length < form.page_size){
          // this.finished = true
        }else if(!res?.data?.list?.length){
        }
        this.finished = true //完成 停止轮询内容
      }).catch(e => {
        console.log(e)
        this.finished = true
      }).finally(()=>{
        this.$Toast.clear()
        this.loading = false
      })
    },
    // 获取行政区列表
    getAreaList(){
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.loading = true
      getAllCity({parentId:this.cityId}).then(res => {
        let list = res?.data || []
        if(list.length){
          list.unshift({
            cityCode:"",
            cityName: '全部',
            id: ''
          })
        }
        this.originalAreaList = list
        this.areaList = list.map(item=>item.cityName)
      }).catch(e => {
        console.log(e)
        this.areaList = []
      }).finally(()=>{
        this.$Toast.clear()
        this.loading = false
      })
    },
    // 选择行政区
    confirmAreaId(e){
      this.areaObj = this.originalAreaList[this.areaList.findIndex(item=>item === e)]
      this.showAreaList = false
      this.getCinemaList()
    },
    toLocation(){
      this.$router.push({
        path:'/location'
      })
    },
    toCinema(item){
      this.$router.push({
        path:'/cinemaDetail',
        query:{
          cinemaid:item.id,
          movieId:this.form.movieId
        }
      })
    },
    onClickLeft(){
      this.$route.params.keyword = this.form.keyword;
      this.$route.query.keyword = this.form.keyword;
      this.$router.back()
    }
  },
  created() {
    this.form.movieId = this.$route.query.movieId
    this.form.city_id = this.$route.query.cityId
    this.form.keyword = this.$route.query.keyword
    this.form.latitude = this.$route.query.latitude
    this.form.longitude = this.$route.query.longitude
    this.getFilmInfo()

  },
  mounted() {
    this.getAreaList()
  },
  computed: {
    cityName(){

      let cityId = this.cityId
      if(this.$store.state.city.cityName === null || this.$store.state.city.cityName === ""  ){this.$store.state.city.cityName =  this.$route.query.cityName}
      console.log("query.cityName:", this.$route.query.cityName);
      return this.$store.state.city.cityName
    },
    cityCode(){
      let id = ''
      let cityName = this.$store.state.city.cityName;
      if(this.cityList.length && cityName){
        this.cityList.map(item=>{
          if(item.cityName === cityName){
            id = item.cityCode
          }
        })
      }
      if(id<=0){id = this.$route.query.cityId }
      return id
    },
    cityId(){ //区号
      let id = ''
      let cityName = this.$store.state.city.cityName;
      if(this.cityList.length && cityName){
        this.cityList.map(item=>{
          if(item.cityName === cityName){
            // id = item.id
            id = item.cityCode
          }
        })
      }
      if(id<=0){id = this.$route.query.cityId }
      return id
    },
    cityList(){
      return this.$store.state.cinema.cityList
    },
    cityPosition(){
      if(!this.$store.state.city.cityPosition.latitude){
        this.$store.state.city.cityPosition.latitude = this.$route.query.latitude
        this.$store.state.city.cityPosition.longitude = this.$route.query.longitude
      }
      return this.$store.state.city.cityPosition
    }
  },
  watch: {
    'form.keyword':{
      handler(){
        this.loading = false
        this.finished = false
        this.cinemaList = []
        this.getCinemaList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  background-color: #ffffff;
  position: relative;
  z-index: 0;
  padding-bottom:20px;
}

.header {
  width: 100%;
  height: 372px;
  display: flex;
  position: relative;
  align-items: center;

  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    overflow: hidden;
    -webkit-filter: blur(.3rem) brightness(0.5);
    filter: blur(.3rem) brightness(0.5);
    background-size: cover;
    background-repeat: no-repeat;
    opacity: .55;
    background-position: 0 50% !important;
  }

  .header-img {
    z-index: 100;
    margin-left: 30px;
    align-self: center;
    width:200px;
    height:300px;
    border-radius: 26px;
    overflow: hidden;
  }

  .header-content {
    align-self: center;
    color: #ffffff;
    margin-left: 30px;
    font-size: 24px;

    &>div {
      line-height: 1.7;
    }

    .title {
      font-size: 40px;
      font-weight: bold;
    }
    .score{
      font-size: 30px;
      &>span{
        color: #FFBD00;
        font-weight: bold;
        font-size:46px
      }
    }
  }
}
.head{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size:28px;
  padding:15px 30px;
  .cityName{
    margin-right:15px;
    background-color: #f7f7f7;
    border-radius: 40px;
    padding: 15px 40px;
    .icon{
      margin-right:10px;
    }
  }
  .search{
    flex:1;
    input[class~=van-field__control]{
      font-size:28px!important;
    }
  }
}

.cinema-list {
  padding: 30px;
  font-size: 28px;
  border-bottom: 1px solid #b1b0b0;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-name {
      font-size: 34px;
      font-weight: bold;
    }

    .distance {
      color: #b1b0b0;
    }
  }

  .address {
    margin-top: 20px;
    color: #676767;
  }
}
.list{
  /*height: calc(100vh - 620px);*/
  overflow-y: auto;
}
</style>
